<template>
    <v-tab-item
        key="extra_charges"
        :transition="false"
        :reverse-transition="false"
    >
        <form-panel>
            <v-data-table
                :items="items"
                :headers="headers"
                class="data-table border-g-e8"
                disable-filtering
                disable-pagination
                hide-default-footer
                :loading="loading"
            >
            </v-data-table>

            <div class="d-flex pt-6">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="newItem">{{
                    $t('actions.create')
                }}</v-btn>
            </div>
        </form-panel>

        <v-dialog v-model="showAdd" max-width="400">
            <v-card>
                <v-card-title> Hozzadas </v-card-title>
                <v-card-text>
                    <v-form v-model="isValid">
                        <text-input
                            v-model="addItem.comment"
                            v-validate.immediate="
                                'required|min:2|max:255|space'
                            "
                            name="comment"
                            label="labels.comment"
                            :error-messages="errors.collect('comment')"
                            :data-vv-as="$t('labels.comment')"
                        ></text-input>
                        <text-input
                            v-model="addItem.chargeNet"
                            v-validate.immediate="
                                'required|min_value:0|decimal:2'
                            "
                            name="charge_net"
                            type="text"
                            label="labels.charge_net"
                            :error-messages="errors.collect('charge_net')"
                            :data-vv-as="$t('labels.charge_net')"
                        ></text-input>
                        <text-input
                            v-model="addItem.chargeVat"
                            v-validate.immediate="'required|decimal:2'"
                            name="charge_vat"
                            type="text"
                            label="labels.charge_vat"
                            :error-messages="errors.collect('charge_vat')"
                            :data-vv-as="$t('labels.charge_vat')"
                        ></text-input>
                        <text-input
                            v-model="addItem.chargeGross"
                            v-validate.immediate="
                                rowValidator(addItem.chargeGross, {
                                    decimal: {
                                        decimals: 2,
                                    },
                                    'invoice-sum': [
                                        addItem.chargeNet,
                                        addItem.chargeVat,
                                    ],
                                })
                            "
                            type="text"
                            name="charge_gross"
                            label="labels.charge_gross"
                            :error-messages="errors.collect('charge_gross')"
                            :data-vv-as="$t('labels.charge_gross')"
                        ></text-input>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="closeEdit">{{ $t('actions.cancel') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="!isValid"
                        color="primary"
                        :loading="loading"
                        @click="save"
                        >{{ $t('actions.create') }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-tab-item>
</template>
<script>
import FormPanel from '@/components/form/FormPanel.vue'
import RestaurantChargesApiClient from '@/api/RestApi/RestaurantChargesApiClient'
import TextInput from '@/components/form/Inputs/TextInput.vue'

export default {
    components: { TextInput, FormPanel },

    props: {
        value: {
            type: Object,
        },
    },

    data() {
        return {
            showAdd: false,
            addItem: {},
            items: [],
            isValid: false,
            loading: true,
            headers: [
                {
                    value: 'comment',
                    text: this.$t('labels.comment'),
                },
                {
                    value: 'chargeNet',
                    text: this.$t('labels.charge_net'),
                },
                {
                    value: 'chargeVat',
                    text: this.$t('labels.charge_vat'),
                },
                {
                    value: 'chargeGross',
                    text: this.$t('labels.charge_gross'),
                },
            ],
        }
    },

    async mounted() {
        this.loadItems()
    },

    methods: {
        rowValidator(invoice, extraValidators = {}) {
            return {
                required: true,
                ...extraValidators,
            }
        },
        newItem() {
            this.showAdd = true
            this.addItem = {
                ordering: this.value['@id'],
            }
        },
        closeEdit() {
            this.showAdd = false
            this.addItem = {}
        },
        async loadItems() {
            const resp = await RestaurantChargesApiClient.list(this.value.id)
            this.items = resp['hydra:member']

            this.loading = false
        },
        async save() {
            if (!this.isValid) {
                return false
            }

            this.addItem.chargeNet = parseFloat(this.addItem.chargeNet)
            this.addItem.chargeVat = parseFloat(this.addItem.chargeVat)
            this.addItem.chargeGross = parseFloat(this.addItem.chargeGross)

            this.loading = true
            await RestaurantChargesApiClient.save(this.addItem)
            await this.loadItems()
            this.closeEdit()
        },
    },
}
</script>
